/**
 * @generated SignedSource<<c3f329f39c67c8664b48f91278a5ff18>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "model"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "model",
            "variableName": "model"
        }
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "schedulable",
        "storageKey": null
    };
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "UserAttributesUpdateModal_updateSchedulableEntityMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "UpdateSchedulableEntityPayload",
                    "kind": "LinkedField",
                    "name": "updateSchedulableEntity",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "EdgeOfISchedulableEntity",
                            "kind": "LinkedField",
                            "name": "entityEdge",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        (v2 /*: any*/)
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "UserAttributesUpdateModal_updateSchedulableEntityMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "UpdateSchedulableEntityPayload",
                    "kind": "LinkedField",
                    "name": "updateSchedulableEntity",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "EdgeOfISchedulableEntity",
                            "kind": "LinkedField",
                            "name": "entityEdge",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "__typename",
                                            "storageKey": null
                                        },
                                        (v2 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "id",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "6dec2bf0c18fa871cf6d0936b5d7a3e9",
            "id": null,
            "metadata": {},
            "name": "UserAttributesUpdateModal_updateSchedulableEntityMutation",
            "operationKind": "mutation",
            "text": "mutation UserAttributesUpdateModal_updateSchedulableEntityMutation(\n  $model: UpdateSchedulableEntityRequestInput!\n) {\n  updateSchedulableEntity(model: $model) {\n    entityEdge {\n      node {\n        __typename\n        schedulable\n        id\n      }\n    }\n  }\n}\n"
        }
    };
})();
node.hash = "d0313c126592bc478910a12715bc1bb3";
export default node;
